export interface VideoPlaybackSnapshot {
    currentTimeSeconds: number;
    ended: boolean;
    paused: boolean;
    readyState: number;
    renderedFrameCount: number;
}

const VIDEO_PROGRESS_EPSILON_SECONDS = 0.01;

type VideoPlaybackElement = Pick<
    HTMLVideoElement,
    'currentTime' | 'ended' | 'paused' | 'readyState' | 'getVideoPlaybackQuality'
>;

export const readVideoPlaybackSnapshot = (
    video: VideoPlaybackElement
): VideoPlaybackSnapshot => {
    const playbackQuality = video.getVideoPlaybackQuality();
    const renderedFrameCount = playbackQuality.totalVideoFrames;
    const snapshot: VideoPlaybackSnapshot = {
        currentTimeSeconds: video.currentTime,
        ended: video.ended,
        paused: video.paused,
        readyState: video.readyState,
        renderedFrameCount
    };
    return snapshot;
};

export const videoPlaybackProgressed = (
    previousSnapshot: VideoPlaybackSnapshot,
    nextSnapshot: VideoPlaybackSnapshot
): boolean => {
    const renderedFramesAdvanced =
        nextSnapshot.renderedFrameCount > previousSnapshot.renderedFrameCount;
    if (renderedFramesAdvanced) {
        return true;
    }

    const minimumExpectedTimeSeconds =
        previousSnapshot.currentTimeSeconds + VIDEO_PROGRESS_EPSILON_SECONDS;
    const currentTimeAdvanced =
        nextSnapshot.currentTimeSeconds > minimumExpectedTimeSeconds;
    return currentTimeAdvanced;
};
